import { createContext } from "react"
import type { VirtualListContextValue } from "./VirtualListContextValue"

type ContextType = VirtualListContextValue | null

export const VirtualListContext = createContext<ContextType>(null)
